export const REACT_APP_BE_API_URL = import.meta.env.REACT_APP_BE_API_URL;
export const REACT_APP_BE_API_STATS_URL = import.meta.env
  .REACT_APP_BE_API_STATS_URL;

export const REACT_APP_ENV = import.meta.env.REACT_APP_ENV ?? 'local';
// Appended to Sentry's environment only; defaults to -v4 so this repo's FE stays apart from the old repo's, empty drops it.
export const REACT_APP_ENV_SUFFIX =
  import.meta.env.REACT_APP_ENV_SUFFIX ?? '-v4';
export const REACT_APP_SSO_AUTHORITY = import.meta.env.REACT_APP_SSO_AUTHORITY;
export const REACT_APP_SSO_AUTHORITY_DOMAIN = import.meta.env
  .REACT_APP_SSO_AUTHORITY_DOMAIN;

const ENV_REACT_APP_SSO_LOG_LEVEL = import.meta.env.REACT_APP_SSO_LOG_LEVEL;
export const REACT_APP_SSO_LOG_LEVEL = ENV_REACT_APP_SSO_LOG_LEVEL
  ? +ENV_REACT_APP_SSO_LOG_LEVEL
  : 4;
export const REACT_APP_SENTRY_DSN = import.meta.env.REACT_APP_SENTRY_DSN;
export const REACT_APP_SSO_CLIENT_ID = import.meta.env.REACT_APP_SSO_CLIENT_ID;
export const REACT_APP_SSO_REDIRECT_URL = import.meta.env
  .REACT_APP_SSO_REDIRECT_URL;
export const REACT_APP_SSO_SCOPES = import.meta.env.REACT_APP_SSO_SCOPES;
export const REACT_APP_VERSION = import.meta.env.REACT_APP_VERSION;
const rawSSOConfig = import.meta.env.REACT_APP_SSO_CONFIG_JSON;
let parsedSSOConfig = {};
try {
  parsedSSOConfig = rawSSOConfig ? JSON.parse(rawSSOConfig) : {};
} catch (error) {
  console.error('Failed to parse REACT_APP_SSO_CONFIG_JSON:', error);
}
export const SSO_CONFIG_OUTPUTS = parsedSSOConfig;

// Cognito custom identity-provider name for the SSO redirect. Shared by
// `AuthProvider` (pre-login) and `handleSessionExpired` (re-auth after a
// mid-session loss), which must target the same provider or the recovery lands the
// user on a different identity than the one they started with.
//
// Hardcoded rather than read from the environment, unlike everything else here:
// there is one TransMedics IdP across every deployment, and the pool/client that
// DO vary per environment already come from `SSO_CONFIG_OUTPUTS`. Move it to an env
// var if a second IdP ever appears.
export const SSO_CUSTOM_PROVIDER = 'transmedics-ad';

export const EIGHT_HOURS = 8 * 60;
export const SIX_HOURS = 6 * 60;
export const FOUR_HOURS = 4 * 60;
export const TWO_HOURS = 2 * 60;

export const REACT_APP_LOGISTICS_BASE_URL = import.meta.env
  .REACT_APP_LOGISTICS_BASE_URL;
/**
 * NOP Connect's origin, for the deep link to a case's full record. **Optional:**
 * an environment without it renders no link rather than a broken one — see
 * `caseResourcesUrl`.
 */
export const REACT_APP_NOP_CONNECT_URL = import.meta.env
  .REACT_APP_NOP_CONNECT_URL;
/**
 * Local development auth bypass: skip the SSO redirect and send API requests
 * with no `Authorization` header, so a developer can open group-guarded pages
 * without a session.
 *
 * PAIRED WITH THE BACKEND. This side only stops the frontend from demanding a
 * token; the API still has to answer an unauthenticated request, which means
 * running a local backend with `BYPASS_MODE=true`. That flag also grants every
 * group, and since `RouteGuard` reads its groups from the backend's
 * `User-Groups` header, it is what actually opens the guarded routes — there is
 * deliberately no frontend-side group faking.
 *
 * HARD-GATED ON `import.meta.env.DEV`, which is `false` for `vite build`. The
 * whole branch is therefore dead code in any production bundle, so setting
 * `REACT_APP_BYPASS_MODE=true` in a deployed environment cannot disable auth.
 * A plain string compare, as the previous `REACT_APP_BYPASS` was, offered no
 * such protection.
 *
 * Renamed from `REACT_APP_BYPASS` to match the backend's `BYPASS_MODE`. An old
 * `.env` still setting the previous name simply gets no bypass, which is the
 * safe direction to fail.
 */
export const IS_BYPASS_MODE =
  import.meta.env.DEV && import.meta.env.REACT_APP_BYPASS_MODE === 'true';

/**
 * Feature flag for External Reference parsing mode
 * - true (default): Supports both legacy and new format parsing
 * - false: Strict new format only (MX/, TRNG/, Repo/, Special/, or Mission with organ)
 */
export const EXTERNAL_REFERENCE_LEGACY_MODE =
  import.meta.env.REACT_APP_EXTERNAL_REFERENCE_LEGACY_MODE !== 'false';
